var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"three-stars fc-flex fc-align-center fc-justify-between"},_vm._l((3),function(index){return _c('font-awesome-icon',{key:index,staticClass:"three-stars__star",attrs:{"icon":['fc', 'star'],"size":"sm"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }